// English customer copy follows the canonical Web v3 October 2 simplification.
// Server-owned policy/outcome text, state transitions and permitted actions remain unchanged.
// Spanish: the Founder's full review of 2026-10-06, applied by scripts/apply-spanish-review.js.

export const en = {
  "terms.agree": "I'm 18 or older and agree to Lura's [Terms of Service].",
  "terms.privacy": "See our [Privacy Policy].",
  "link.newTab": " (opens in a new tab)",
  "terms.unavailable.booking": "We couldn’t load the terms.",
  "terms.unavailable.account": "We couldn’t load the terms.",
  "terms.reload": "Try again",
  "terms.changed.title": "The terms changed.",
  "terms.changed.body": "Read them and agree again.",
} as const;
